import React from 'react';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';

export default function Hero({
  title,
  subTitle,
  bgUrl,
  imgUrl,
  videoBtnText,
  videoUrl,
  infoList,
  btnText,
  btnUrl,
}) {
  return (
    <section id="hero" className="min-h-screen grid grid-cols-1 md:grid-cols-2 relative pt-[80px]">
      <div className="flex flex-col justify-center px-6 md:pl-24 md:pr-16 py-20 md:py-24 relative z-[2]">
        <div className="inline-flex items-center gap-[0.6rem] text-[0.72rem] tracking-[0.2em] uppercase text-gold font-medium mb-[1.8rem] animate-[fadeUp_0.7s_ease_forwards_0.1s]">
          <span className="w-[30px] h-px bg-gold block"></span>
          Mental Health & Wellbeing
        </div>
        
        <h1 className="font-serif text-4xl md:text-5xl lg:text-[5rem] font-light leading-[1.1] text-charcoal mb-8 animate-[fadeUp_0.7s_ease_forwards_0.25s]">
          {parse(React.isValidElement(title) ? title : String(title || 'Healing minds,<br/><i className="italic text-crimson">transforming</i><br/>communities.'))}
        </h1>
        
        <p className="text-base leading-[1.75] text-mid max-w-[420px] mb-12 font-light animate-[fadeUp_0.7s_ease_forwards_0.4s]">
          {parse(React.isValidElement(subTitle) ? subTitle : String(subTitle || 'Noohra Integrated & Allied Services Ltd. provides comprehensive mental health care, training, and corporate wellness programs — rooted in compassion, grounded in science.'))}
        </p>
        
        <div className="flex gap-4 items-center animate-[fadeUp_0.7s_ease_forwards_0.55s]">
          <Link to={btnUrl || "#contact"} className="inline-block bg-crimson text-white px-[2.2rem] py-[0.9rem] text-[0.8rem] font-medium tracking-[0.12em] uppercase rounded-sm transition-all duration-250 hover:bg-crimson-dark hover:-translate-y-px hover:shadow-[0_8px_24px_rgba(139,26,26,0.25)]">
            {btnText || "Book a Session"}
          </Link>
          <a href="#services" className="inline-flex items-center gap-2 text-crimson text-[0.8rem] font-medium tracking-[0.1em] uppercase border-b border-crimson pb-[2px] transition-all duration-200 hover:gap-3">
            Our Services &rarr;
          </a>
        </div>
      </div>
      
      <div className="relative overflow-hidden min-h-[300px] md:min-h-full">
        <div className="absolute inset-0 bg-gradient-to-br from-crimson-dark via-crimson to-[#B82525]"></div>
        <img src={bgUrl || "/images/home_1/20250131_103646.jpg"} alt="Hero" className="absolute inset-0 w-full h-full object-cover object-top z-10" />
        <div className="absolute inset-0 bg-gradient-to-b from-[rgba(139,26,26,0.45)] to-[rgba(80,10,10,0.65)] z-20"></div>
        
        <div className="relative z-30 h-full flex flex-col justify-end items-start p-6 md:p-12">
          <div className="grid grid-cols-2 gap-4 w-full max-w-[380px] mb-8">
            <div className="bg-white/10 border border-white/20 rounded py-[1.4rem] px-[1.2rem] backdrop-blur-md text-center">
              <div className="font-serif text-[2.4rem] font-light text-white leading-none mb-1">300+</div>
              <div className="text-[0.68rem] tracking-[0.1em] uppercase text-white/70 font-normal">People Served</div>
            </div>
            <div className="bg-white/10 border border-white/20 rounded py-[1.4rem] px-[1.2rem] backdrop-blur-md text-center">
              <div className="font-serif text-[2.4rem] font-light text-white leading-none mb-1">10+</div>
              <div className="text-[0.68rem] tracking-[0.1em] uppercase text-white/70 font-normal">Years Experience</div>
            </div>
            <div className="bg-white/10 border border-white/20 rounded py-[1.4rem] px-[1.2rem] backdrop-blur-md text-center">
              <div className="font-serif text-[2.4rem] font-light text-white leading-none mb-1">20+</div>
              <div className="text-[0.68rem] tracking-[0.1em] uppercase text-white/70 font-normal">Workshops Run</div>
            </div>
            <div className="bg-white/10 border border-white/20 rounded py-[1.4rem] px-[1.2rem] backdrop-blur-md text-center">
              <div className="font-serif text-[2.4rem] font-light text-white leading-none mb-1">3+</div>
              <div className="text-[0.68rem] tracking-[0.1em] uppercase text-white/70 font-normal">Org. Partners</div>
            </div>
            <div className="bg-white/10 border border-white/20 rounded py-[1.4rem] px-[1.2rem] backdrop-blur-md text-center">
              <div className="font-serif text-[2.4rem] font-light text-white leading-none mb-1">15+</div>
              <div className="text-[0.68rem] tracking-[0.1em] uppercase text-white/70 font-normal">Volunteers & Interns</div>
            </div>
            <div className="bg-white/10 border border-white/20 rounded py-[1.4rem] px-[1.2rem] backdrop-blur-md text-center">
              <div className="font-serif text-[2.4rem] font-light text-white leading-none mb-1">15+</div>
              <div className="text-[0.68rem] tracking-[0.1em] uppercase text-white/70 font-normal">Trainees</div>
            </div>
          </div>
          <div className="max-w-[340px]">
            <p className="font-serif italic text-[1.2rem] text-white/90 leading-relaxed">"Mental health is not a destination, but a process."</p>
            <span className="block mt-2 font-sans text-[0.7rem] tracking-[0.15em] uppercase text-gold-light">&mdash; Our Philosophy</span>
          </div>
        </div>
      </div>
    </section>
  );
}
